<div id="not-found">
    <div class="mars"></div>
<img src="/assets/svg/not-found/404.svg" class="logo-404" />
<img src="/assets/svg/not-found/meteor.svg" class="meteor" />
<p class="title">Oh no!!</p>
<p class="subtitle">
	You’re either misspelling the URL <br /> or page is under maintenance.
</p>
<div class="text-center">
	<a class="btn-back" href="#">Back to previous page</a>
</div>
<img src="/assets/svg/not-found/astronaut.svg" class="astronaut" />
<img src="/assets/svg/not-found/spaceship.svg" class="spaceship" />
</div>